import React, { useState } from "react";
import {
    Box,
    Menu,
    MenuItem,
    Button,
    Typography,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

interface MultiLevelActionProps {
    actionValue?: any[];
}

const MultiLevelAction = ({ actionValue }: MultiLevelActionProps) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [activeParentIndex, setActiveParentIndex] = useState<number | null>(null);

    const handleParentClick = (
        event: React.MouseEvent<HTMLButtonElement>,
        index: number
    ) => {
        setAnchorEl(event.currentTarget);
        setActiveParentIndex(index);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setActiveParentIndex(null);
    };

    return (
        <>
            {actionValue?.map((action, actionIndex) => {

                const menuData =
                    action?.config_details?.value?.value || [];

                const selected = action?.selected?.[0];

                return (
                    <Box key={actionIndex} mb={3}>
                        <Typography sx={{ fontWeight: 'bold', marginRight: '20px' }}>
                            {action?.config_details?.value?.label}:
                        </Typography>
                        {/* <Box display="flex" gap={1} flexWrap="wrap">
                            {menuData.map((item: any, index: number) => (
                                <Button
                                    key={item.category}
                                    variant={
                                        selected?.category === item.category
                                            ? "contained"
                                            : "outlined"
                                    }
                                    onClick={(e) => handleParentClick(e, index)}
                                    endIcon={
                                        activeParentIndex === index ? (
                                            <ChevronRightIcon />
                                        ) : null
                                    }
                                >
                                    {item.category}
                                </Button>
                            ))}
                        </Box> */}

                        {/* {activeParentIndex !== null && (
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                            >
                                {menuData[activeParentIndex]?.sub_category?.map(
                                    (child: any) => (
                                        <MenuItem
                                            key={child.category}
                                            sx={{
                                                minWidth: 220,
                                                fontWeight:
                                                    selected?.sub_category === child.category
                                                        ? 600
                                                        : 400,
                                            }}
                                        >
                                            {child.category}
                                        </MenuItem>
                                    )
                                )}
                            </Menu>
                        )} */}

                        {selected && (
                            <Box mt={2}>
                                {/* <Typography variant="body2" color="text.secondary">
                                    Selected Value
                                </Typography> */}
                                <Typography variant="subtitle1" fontWeight={600}>
                                    {selected.category} → {selected.sub_category}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                );
            })}
        </>
    );
};

export default MultiLevelAction;
